import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { ContactCase } from 'types/contacts'
import { PaymentsResponse } from 'types/payments'
import { SidePanelCopyRow } from './SidePanelCopyRow'
import { SidePanelRow } from './SidePanelRow'

export type PaymentInSidePanelBodyProps = {
  payment: PaymentsResponse
  contactCase: ContactCase
}

export const PaymentInSidePanelBody = ({ payment, contactCase }: PaymentInSidePanelBodyProps) => {
  const { t } = useTranslation()

  const paidCurrency = payment?.paidCurrency
  const walletCurrency = payment?.walletCurrency
  const exchangeRate = payment?.exchangeRate
  const address = payment?.address

  return (
    <Box flexCol gapY={12}>
      <SidePanelRow
        label={t('transactions.sideBar.paymentInAmountReceived')}
        content={`${walletCurrency?.amount} ${walletCurrency?.currency}`}
      />
      <SidePanelRow
        label={t('transactions.sideBar.paymentOutAmountPaid')}
        content={`${paidCurrency?.amount} ${paidCurrency?.currency}`}
      />
      <SidePanelRow
        label={t('transactions.sideBar.paidIntoWallet')}
        content={`${payment?.merchantDisplayName}`}
      />
      <SidePanelRow
        label={t('transactions.sideBar.exchangeRate')}
        content={`1 ${exchangeRate?.base} = ${exchangeRate?.rate} ${exchangeRate?.counter}`}
      />
      <SidePanelRow
        label={t('transactions.sideBar.transactionType')}
        content={`${t('paymentIn')}`}
      />
      <SidePanelCopyRow
        label={t('transactions.sideBar.sourceAddress')}
        content={`${address?.address}`}
      />
      <SidePanelCopyRow
        label={t('transactions.sideBar.reference')}
        content={`${payment?.reference}`}
      />
      <SidePanelCopyRow label={t('transactions.sideBar.uuid')} content={`${payment?.uuid}`} />
      <SidePanelCopyRow label={t('transactions.sideBar.hash')} content={`${contactCase?.hash}`} />
    </Box>
  )
}
